<template>
  <div class="component-content configuration-seatpost">
    <div class="uppercase xs-text bold mb-4">Select your seatpost</div>

    <option-list
      :options="seatpostInput"
      :target="this.results.seatpost"
      :inputName="'setpost'"
      v-on:target-updated="updateData"
    ></option-list>

    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import OptionList from "../../shared/optionList.vue";

export default {
  name: "configuration-seatpost",
  data() {
    return {};
  },
  components: {
    OptionList,
  },
  props: ["configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    updateData: function (e) {
      this.seatpostInput = e;
    },
  },
  computed: {
    seatpostInput: {
      get: function () {
        return this.components.seatpost[0];
      },
      set: function (e) {
        this.$emit("set-seatpost", e);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-seatpost {
}
</style>

